import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';

import { navigate, setTitle } from '../../../actions/core.actions';
import { setBrowserTitle } from '../../../actions/core.actions';
import { getTopic, initializeGetTopicState } from '../../../actions/topic.actions';
import { RootState } from '../../../reducers';
import * as GetTopicSelectors from 'src/app/selectors/topic.selectors';

import { Topic, GetTopicRequest, GetTopicResponse } from 'src/app/models/topic';
import { WINDOW_OBJECT } from '../../../utils/injection-tokens';
import { Dates } from '../../../utils/dates';
import { RoutingPathResolver } from '../../../app-routing-path-resolver';
import { enter } from '../../../resources/animations';

@Component({
  selector: 'app-topic',
  templateUrl: './topic.component.html',
  styleUrls: ['./topic.component.scss'],
  animations: [enter]
})
export class TopicComponent implements OnInit, AfterViewInit, OnDestroy {
  topic: Topic;
  isTopicLoading = true;

  private LOG_SOURCE = this.constructor.name;
  private title = 'トピック';

  constructor(
    private store: Store<RootState>,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    @Inject(WINDOW_OBJECT) private window: Window
  ) {}

  ngOnInit() {
    this.store.dispatch(setBrowserTitle({ subTitle: this.title }));
    setTimeout(() => this.store.dispatch(setTitle({ title: this.title })));
    this.setUpTopic();
  }

  ngAfterViewInit() {
    setTimeout(() => window.scrollTo(0, 0));
  }

  ngOnDestroy(): void {
    this.store.dispatch(initializeGetTopicState());
  }

  sanitize(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  /* リンクボタンはコメントアウトしておく
  gotoContact(linkUrl: string) {
    this.store.dispatch(openWindow({ url: linkUrl }));
  }
  */

  private setUpTopic() {
    this.store.dispatch(initializeGetTopicState());

    const topicId: string = this.activatedRoute.snapshot.paramMap.get('topicId');
    const request: GetTopicRequest = { topicId };
    this.store.dispatch(getTopic({ request }));

    this.store
      .select(GetTopicSelectors.getTopic)
      .pipe(
        filter(it => it != null),
        take(1)
      )
      .subscribe(result => {
        if (result.success) {
          this.topic = this.getEditedTopic(result.response);
          this.isTopicLoading = false;
        } else {
          // エラーの場合はBtoSのトップ画面に遷移
          this.store.dispatch(navigate({ url: RoutingPathResolver.resolveTop() }));
        }
      });
  }

  private getEditedTopic(topic: GetTopicResponse): Topic {
    // 発行日の編集を行う
    const publishedAt = Dates.simple4YmdStringFromIso(topic.publishedAt);
    const result: Topic = {
      id: topic.id,
      publishedAt,
      title: topic.title,
      body: topic.body,
      linkLabel: topic.linkLabel,
      linkUrl: topic.linkUrl
    };
    return result;
  }
}
